import type { LatLng } from "@/models"

export enum LatLngFormatType {
	DegreesDecimalMinutes = "DDM",
	DecimalDegrees = "DD",
}

export function formatLatLng(loc: LatLng, type: LatLngFormatType): string {
	return `${formatLatLngPart(loc.latitude, "latitude", type)}, ${formatLatLngPart(loc.longitude, "longitude", type)}`
}

export function formatLatLngPart(coordinate: number, part: keyof LatLng, type: LatLngFormatType): string {
	switch (type) {
		case LatLngFormatType.DecimalDegrees:
			return formatDD(coordinate)
		case LatLngFormatType.DegreesDecimalMinutes:
			return formatDDM(coordinate, part)
	}
	throw new Error("Unknown format type")
}

export function fixLatLng(location: LatLng): LatLng {
	return {
		latitude: withinRange(location.latitude, -90, 90),
		longitude: withinRange(location.longitude, -180, 180),
	}
}

function formatDDM(value: number, type: keyof LatLng): string {
	const positiveUnit = type === "latitude" ? "N" : "E"
	const negativeUnit = type === "latitude" ? "S" : "W"
	const unit = value < 0 ? negativeUnit : positiveUnit

	const degrees = Math.trunc(Math.abs(value))
	const decimalMinutes = (Math.abs(value) - degrees) * 60

	return `${degrees}°${decimalMinutes.toFixed(3)}'${unit}`
}

function formatDD(value: number) {
	return value.toFixed(5)
}

function withinRange(value: number, min: number, max: number) {
	const range = max - min
	while (value < min) {
		value += range
	}
	while (value > max) {
		value -= range
	}
	return value
}
